/********************** MAKE HEADER STICKY NAV BAR JS START  **********************/
if(window.innerWidth > 1000){
  // Get the navbar
  const navbar = document.querySelector('.shopify-section__header');

  if(navbar){
      // Get the offset position of the navbar
    const navbarOffsetTop = navbar.offsetTop;

    // Function to handle scroll
    function handleScroll() {
      // console.log("offset: ", window.pageYOffset, navbarOffsetTop);
        if (window.pageYOffset > navbarOffsetTop) {
            navbar.classList.add('sticky-navbar');
        } else {
            navbar.classList.remove('sticky-navbar');
        }
    }

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Optional: Add throttling for better performance
    let ticking = false;

    function throttledScroll() {
        if (!ticking) {
            requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    }

    // Replace the simple scroll listener with throttled version for better performance
    window.removeEventListener('scroll', handleScroll);
    window.addEventListener('scroll', throttledScroll);

    // Optional: Handle window resize
    window.addEventListener('resize', () => {
        // Recalculate offset position on resize
        const newOffsetTop = navbar.offsetTop;
        if (window.pageYOffset > newOffsetTop) {
            navbar.classList.add('sticky-navbar');
        } else {
            navbar.classList.remove('sticky-navbar');
        }
    });
  }
}
/********************** MAKE HEADER STICKY NAV BAR JS END  **********************/


const header_effect = document.querySelector(".header--section[data-section-type='header']");

if(header_effect){
  window.addEventListener("scroll", () => {
    if (window.scrollY > 50) { // add class after 50px scroll
      header_effect.classList.add("on-scrolled");
    } else {
      header_effect.classList.remove("on-scrolled");
    }
  });
}


/********************** MEGA MENU PRODUCT COLLECTION JS START  **********************/
document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('#mega-menu-tabs .tab-btn');
    const tabContents = document.querySelectorAll('#mega-menu-tabs .tab-content');

    tabButtons.forEach((btn) => {
        btn.addEventListener('click', function () {
        // Remove active from all buttons and contents
        tabButtons.forEach((b) => b.classList.remove('active'));
        tabContents.forEach((tc) => tc.classList.remove('active'));

        // Add active to clicked button
        this.classList.add('active');

        // Show corresponding content
        let tabId = this.getAttribute('data-tab');
        document.getElementById(tabId).classList.add('active');
        });
    });
});
/********************** MEGA MENU PRODUCT COLLECTION JS END  **********************/

/********************** MEGA MENU PRODUCT COLLECTION JS START  **********************/
document.addEventListener('DOMContentLoaded', function() {
  const drawerBtn = document.getElementById('surfer--widget-toggle');
  const drawer = document.getElementById('top-rated-products-drawer');
  const drawerClose = document.getElementById('surfer--drawer-close');
  const overlayClose = document.getElementById("side-drawer-overlay");

  if(drawerBtn){
    drawerBtn.onclick = function() {
      drawer.classList.add('open');
      if (overlayClose) overlayClose.style.display = "block";
    };
  }

  if(drawerClose){
    drawerClose.onclick  = function() {
      drawer.classList.remove('open');
      if (overlayClose) overlayClose.style.display = "none";
    };
  }
  
  if(overlayClose){
    overlayClose.onclick = function() {
      drawer.classList.remove('open');
      if (overlayClose) overlayClose.style.display = "none";
    };
  }
  
  // Optional: close drawer when clicking outside
  window.onclick = function(event) {
    if (event.target == drawer) {
      drawer.classList.remove('open');
    }
  };
});

/********************** MEGA MENU PRODUCT COLLECTION JS END  **********************/

// var carouselElem = document.querySelector('.slideshow');

// carouselElem.addEventListener('change', function(event) {
//   console.log("Element: ",  event);
//   // Remove 'animate-in' from all cells
//   var cells = document.querySelectorAll('.carousel-cell');
//   cells.forEach(function(cell) {
//     cell.classList.remove('animate-in');
//   });

//   // Add 'animate-in' to the selected cell
//   var selectedCell = cells[flkty.selectedIndex];
//   if (selectedCell) {
//     selectedCell.classList.add('animate-in');
//   }
// });




/********************** PRODUCT PAGE JS START  **********************/
if(window.location.href.includes('products')){
  const readMoreBtn = document.querySelector('.read-more-btn');
  const main_description = document.querySelector('.description');
  const description = document.querySelector('.description p');

  if(readMoreBtn){
    readMoreBtn.addEventListener('click', () => {
      main_description.classList.toggle('expanded');
      readMoreBtn.textContent = main_description.classList.contains('expanded')
        ? 'Read less'
        : 'Read more';
    });
  }
}

if(window.location.href.includes('products')){
  (function(){
    const accordion = document.getElementById('myAccordion');
    if(accordion){
      const triggers = Array.from(accordion.querySelectorAll('.accordian_trigger'));
      const singleOpen = true; // set false to allow multiple open panels

      function openItem(item, panel){
        const inner = panel.querySelector('.accordian_inner');
        // remove hidden to make scrollHeight measurable
        panel.hidden = false;
        // set max-height to content height to trigger transition
        const height = inner.scrollHeight;
        panel.style.maxHeight = height + 'px';
        item.classList.add('open');
        item.querySelector('.accordian_trigger').setAttribute('aria-expanded','true');
      }

      function closeItem(item, panel){
        const inner = panel.querySelector('.accordian_inner');
        // To animate collapse from current height -> 0, set current height then to 0
        panel.style.maxHeight = inner.scrollHeight + 'px';
        // Force repaint so the transition registers
        requestAnimationFrame(() => {
          panel.style.maxHeight = '0px';
        });
        item.classList.remove('open');
        item.querySelector('.accordian_trigger').setAttribute('aria-expanded','false');

        // after transition finishes, hide to remove from assistive tech flow if collapsed
        panel.addEventListener('transitionend', function handle(){
          if (panel.style.maxHeight === '0px') {
            panel.hidden = true;
          }
          panel.removeEventListener('transitionend', handle);
        });
      }

      // toggle handler
      triggers.forEach((btn) => {
        const item = btn.closest('.accordian_item');
        const panel = item.querySelector('.accordian_panel');

        // ensure aria states start consistent with hidden attribute
        btn.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');

        btn.addEventListener('click', (e) => {
          const isOpen = btn.getAttribute('aria-expanded') === 'true';
          if (isOpen){
            closeItem(item, panel);
          } else {
            if (singleOpen) {
              // close others first
              const otherItems = Array.from(accordion.querySelectorAll('.accordian_item.open'));
              otherItems.forEach(other => {
                if (other !== item){
                  const otherPanel = other.querySelector('.accordian_panel');
                  closeItem(other, otherPanel);
                }
              });
            }
            openItem(item, panel);
          }
        });

        // keyboard support on trigger: Enter/Space already activates button; add arrow navigation
        btn.addEventListener('keydown', (ev) => {
          const idx = triggers.indexOf(btn);
          if (ev.key === 'ArrowDown'){
            ev.preventDefault();
            const next = triggers[(idx + 1) % triggers.length];
            next.focus();
          } else if (ev.key === 'ArrowUp'){
            ev.preventDefault();
            const prev = triggers[(idx - 1 + triggers.length) % triggers.length];
            prev.focus();
          } else if (ev.key === 'Home'){
            ev.preventDefault();
            triggers[0].focus();
          } else if (ev.key === 'End'){
            ev.preventDefault();
            triggers[triggers.length - 1].focus();
          }
        });

        // Make sure panels that start visible have correct inline max-height (optional)
        if (!panel.hidden){
          const inner = panel.querySelector('.accordian_inner');
          panel.style.maxHeight = inner.scrollHeight + 'px';
          item.classList.add('open');
          btn.setAttribute('aria-expanded','true');
        }
      });

      // Optional: on window resize, update open panels' max-heights so they fit new width
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          accordion.querySelectorAll('.accordian_item.open .accordian_panel').forEach(panel => {
            const inner = panel.querySelector('.accordian_inner');
            panel.style.maxHeight = inner.scrollHeight + 'px';
          });
        }, 120);
      });
    }
  })();
}
/********************** PRODUCT PAGE JS END  **********************/


/********************** PAGINATION JS START  **********************/
// if(window.innerWidth < 641){
//   if(window.location.href.includes("collections")){
//     const paginatiion_link = document.querySelectorAll(".surfer--pagination__nav-item");
//     if(paginatiion_link.length > 0){
//       (function () {
//         let lastUrl = location.href;

//         // Patch pushState
//         const pushState = history.pushState;
//         history.pushState = function () {
//           pushState.apply(this, arguments);
//           checkUrl();
//         };

//         // Patch replaceState
//         const replaceState = history.replaceState;
//         history.replaceState = function () {
//           replaceState.apply(this, arguments);
//           checkUrl();
//         };

//         // Detect back/forward navigation
//         window.addEventListener("popstate", checkUrl);

//         function checkUrl() {
//           const currentUrl = location.href;
//           if (currentUrl !== lastUrl) {
//             lastUrl = currentUrl;
//             console.log("URL changed:", currentUrl);

//             // ★ Reload page when URL changes
//             location.reload();       
//           }
//         }
//       })();
//     }
//   }
// }

if (window.innerWidth < 641 && window.location.href.includes("collections")) {
  const paginationLinks = document.querySelectorAll(".surfer--pagination__nav-item");

  if (paginationLinks.length > 0) {
    (function () {
      let lastUrl = location.href;

      window.addEventListener("popstate", function () {
        const currentUrl = location.href;

        if (currentUrl !== lastUrl) {
          lastUrl = currentUrl;
          console.log("Back button detected:", currentUrl);

          // Reload page ONLY on back/forward navigation
          window.location.reload();
        }
      });
    })();

    paginationLinks.forEach((pageNum) => {
      pageNum.addEventListener("click", () => {
        // Scroll to top after navigation
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        }, 300);
      });
    });
  }
}
/********************** PAGINATION JS END  **********************/

// window.addEventListener("load", function () {
//   if ( window.innerWidth < 641 && window.location.href.includes("collections")) {
//      setTimeout (()=> {
//               // ✅ SCROLL TO TOP FIRST
//               window.scrollTo({
//                 top: 0,
//                 behavior: "smooth"
//               });
//             },150);
//   }
// });



/********************** INVENTORY QUANTITY UPDATE RANDOMLY JS START  **********************/

document.addEventListener("DOMContentLoaded", function () {
  const inventoryTextEl = document.querySelector('.inventory-left--content');
  if (!inventoryTextEl) return;

  let text = inventoryTextEl.innerText;

  // Check if text contains a number
  const numberMatch = text.match(/\d+/);
  if (!numberMatch) return;

  // Generate random number between 1 and 3
  const randomNumber = Math.floor(Math.random() * 3) + 1;

  // Replace existing number with random number
  const updatedText = text.replace(/\d+/, randomNumber);

  inventoryTextEl.innerText = updatedText;
});

/********************** INVENTORY QUANTITY UPDATE RANDOMLY JS END  **********************/

/********************** SHOW DELIVERY DATE AFTER 3 DAY'S JS START  **********************/

// document.addEventListener("DOMContentLoaded", function () {
//   const deliveryEl = document.getElementById("deliveryDate");
//   if (!deliveryEl) return;

//   const today = new Date();
//   const deliveryDate = new Date(today);
//   deliveryDate.setDate(today.getDate() + 4);

//   const options = { day: 'numeric', month: 'long', year: 'numeric' };
//   const formattedDate = deliveryDate.toLocaleDateString('en-GB', options);

//   deliveryEl.textContent = formattedDate;
// });


// document.addEventListener("DOMContentLoaded", () => {
//   const els = document.querySelectorAll(".deliveryDate");
//   if (!els.length) return;

//   const d = new Date();
//   d.setDate(d.getDate() + 4);

//   const formatted = d.toLocaleDateString("en-GB", {
//     day: "numeric",
//     month: "long",
//     year: "numeric"
//   });

//   els.forEach(el => el.innerText = formatted);
// });

// document.addEventListener("DOMContentLoaded", () => {
//   const els = document.querySelectorAll(".deliveryDate");
//   if (!els.length) return;

//   const d = new Date();
//   d.setDate(d.getDate() + 4);

//   const day = d.getDate();
//   const month = d.toLocaleString("en-GB", { month: "long" });
//   const year = d.getFullYear();

//   // Day suffix function
//   function getDaySuffix(day) {
//     if (day >= 11 && day <= 13) return "th"; // 11,12,13 = always th
//     switch (day % 10) {
//       case 1: return "st";
//       case 2: return "nd";
//       case 3: return "rd";
//       default: return "th";
//     }
//   }

//   const formatted = `${day}${getDaySuffix(day)} ${month} ${year}`;

//   els.forEach(el => el.innerText = formatted);
// });

/********************** SHOW DELIVERY DATE AFTER 3 DAY'S JS END  **********************/